import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { Title } from '@angular/platform-browser';
import { BreadcrumbsService } from '../breadcrumbs/breadcrumbs.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { BuywifiService } from '../../services/buywifi.service';
import { ConfirmationService } from '../confirmation/confirmation.service';
import { AppService } from '../../app.service';
import { ErrorService } from '../error/error.service';
import { LandingService } from '../landing/landing.service';
import { SwitchService } from '../switch/switch.service';
import { TravellersService } from '../travelers/travellers.service';
import { TravelersService } from '../travelers/travelers.service';
import { DatalayerService } from '../../services/datalayer.service';
import { APP_TRANSLATE } from '../../app.translation.en';
import { LandingComponent } from '../landing/landing.component';
import { PaymentSelectionComponent } from '../eb/paymentSelection.component';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent implements OnInit {
public price: number;
public origin: any;
public destination: any;
public flightNumber: any;
public wifiKey: number;
public passengerDetails: any;
public receiptEmailAddress: any;
public currentSegment: any;
activateCallSuccess = false;
loadContTxt = APP_TRANSLATE.loaderTextWhenConnecting;
loaderTextList = { loaderHeaderText: this.loadContTxt, loaderSubHeaderText: APP_TRANSLATE.loaderSubHeaderTextWhenConnecting };
activateCallCompleted = false;
showBokrefFileds = true;
showEuroBonusFileds = false;
isCharter: boolean;
public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
@HostListener('window:keydown', ['$event'])
keyEvent(event) {
  if (!event.shiftKey && event.target.id === 'total-price' && event.keyCode === 9) {
    event.preventDefault();
    this.accessibilityService.focus('.icon-logo');
  }
}

constructor(private router: Router,
  private breadcrumbsService: BreadcrumbsService,
  private accessibilityService: AccessibilityService,
  private buywifiService: BuywifiService,
  private confirmationService: ConfirmationService,
  private appService: AppService,
  private httpService: HttpService,
  private errorService: ErrorService,
  private landingService: LandingService,
  private switchService: SwitchService,
  private travellersService: TravellersService,
  private ngZone: NgZone,
  private titleService: Title,
  private travelersService: TravelersService,
  private datalayerService: DatalayerService) { }

ngOnInit() {
  this.buywifiService.setCurrentState(2);
  this.accessibilityService.focus('#confirmation-header');
  this.wifiKey = this.buywifiService.getSessionValue();
  this.isCharter = this.appService.isCharter;
  if (!this.showEBforPointsBuy) {
    this.currentSegment = this.buywifiService.getCurrentSegment();
    this.price = this.buywifiService.getCurrentPrice();
    this.datalayerService.pushInformationToDataLayer('wifi-confirmation');
    if (this.appService.isCharter) {
      this.passengerDetails = this.travelersService.getCharterFormData();
    } else {
      this.passengerDetails = this.buywifiService.getPassengerResponse();
    }
    this.travellersService.clearPassengerDetails();
    if (this.appService.isCharter) {
      this.receiptEmailAddress = this.passengerDetails.email.toLowerCase();
    } else {
      this.receiptEmailAddress = this.buywifiService.receiptEmailAddress.toLowerCase();
    }
  }
  else {
    if (this.appService.isCharter) {
      this.passengerDetails = this.travelersService.getCharterFormData();
    } else {
      this.passengerDetails = this.buywifiService.getPassengerResponse();
    }
    this.price = this.buywifiService.getPointsOfferResponse().points;
    this.origin = this.buywifiService.getOriginFromFlightResponse();
    this.destination = this.buywifiService.getDestinationFromFlightResponse();
    this.flightNumber = this.appService.getFlightResponse().flightNumber;
    this.receiptEmailAddress = this.buywifiService.getOrderResponse().receiptEmailId;    
  }  
  
  this.titleService.setTitle('Onboard confirmation - SAS');
  this.accessibilityService.setSkipLinkId('startsurf-btn');
  this.accessibilityService.updateHtmlStyle();
  this.buywifiService.setReserveResponse(null);
  LandingComponent.showActivateScreen = false;
  if(document.getElementById("turi-float-btn")){
    document.getElementById("turi-float-btn").style.visibility= "hidden"
  }
}

startSurfing() { 
  this.appService.showLoaderWithText(this.loaderTextList);
  const getDeviceData = this.appService.getDeviceResponse();
  const activateRequest = this.confirmationService.getActivateCallRequest(getDeviceData, this.passengerDetails, 
    this.landingService.getDeviceName());
  this.doActivateApiCall(activateRequest, 'pnr');
}


doActivateApiCall(request, type) {
  this.httpService.postData(request).subscribe(
    activateResponse => {
      if (activateResponse.errors) {
        for (const error of activateResponse.errors) {
          if (error.errorCode === '7011016') {
            this.getDeciveTypeCall(activateResponse, request);
          } else {
            this.activateCallSuccess = false;
            if (error.errorCode.substring(0, 1) === '7') {
              const singleError = [];
              singleError.push(error);
              this.errorService.addError(singleError);
            } else {
              const despError = [{ 'type': 'despOnly', 'desp': error.errorMessage }];
              this.errorService.addError(despError);
            }
            this.appService.hideLoaderWithText();
            this.activateCallCompleted = true;
          }
        }
      } else if (activateResponse.status && activateResponse.status.code === 'FULL') {
        this.activateCallSuccess = true;
        this.landingService.hideLandingBannerText();
        this.appService.redirectToHomePage();
        this.errorService.addConnectedNotification();
        this.appService.changeDisconnectWifiStatus();
        this.appService.showLandingCustomer();
        this.appService.showLoaderWithText(this.loaderTextList);
        this.appService.addScrollBody();
        this.appService.setFromPage('confirmation');
        this.appService.scrollToTop();
        this.datalayerService.activateDataLayer('Connection successful  - Booking reference');
        this.landingService.getNetFlixBanner(activateResponse.status.code);
        this.activateCallCompleted = true;
      }
    },
    error => {
      this.activateCallSuccess = false;
      this.errorService.addError(this.buywifiService.getDefaultError());
      this.appService.hideLoaderWithText();
      this.activateCallCompleted = true;
    }
  )
}

getDeciveTypeCall(activateResponse, request) {
  for (const link of activateResponse.links) {
    if (link.rel === 'PassengerAssociatedDevices') {
      const paxId = link.href.split('=')[1];
      const getDeviceTypeRequest = this.confirmationService.getDeviceTypesRequest(paxId);
      this.httpService.getData(getDeviceTypeRequest).subscribe(
        deviceTypeResponse => {
          if (deviceTypeResponse.errors) {
            this.activateCallSuccess = false;
            this.errorService.addError(deviceTypeResponse.errors);
            this.appService.showLoaderWithText(this.loaderTextList);
          } else {
            this.activateCallSuccess = true;
            this.switchService.setConnectedCount(deviceTypeResponse);
            this.switchService.setDataFromLanding(deviceTypeResponse, this.landingService.getGetDeviceResponse(), paxId);
            this.errorService.removeError();
            this.showBokrefFileds = false;
            this.showEuroBonusFileds = false;
            LandingComponent.showSwitchScreen = true;
            this.appService.redirectToHomePage();
            this.landingService.hideActivateScreen();
          }
          this.activateCallCompleted = true;
        },
        error => {
          this.activateCallSuccess = false;
          this.errorService.addError(this.landingService.getDefaultError());
          this.appService.hideLoaderWithText();
          this.activateCallCompleted = true;
        }
      )
    }
  }
}
}
